<template>
  <div v-if="hasDivergence">
    <v-row>
      <v-col>
        <h2>{{ $t('appointment.label.divergenceRecalculation') }}</h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6">
        <h6 class="text-uppercase grey--text">
          {{ $t('appointment.label.divergenceTypes') }}:
        </h6>
        <span class="body-2">{{ types }}</span>
      </v-col>
      <v-col cols="12" md="6">
        <h6 class="text-uppercase grey--text">
          {{ $t('appointment.label.divergenceContestDeadline') }}:
        </h6>
        <span class="body-2">{{ deadlineLabel }}</span>
      </v-col>
    </v-row>
    <v-row v-if="!contest.can_contest">
      <v-col>
        <span class="body-2 grey--text">
          {{ $t('appointment.label.divergenceContestExpired') }}
        </span>
      </v-col>
    </v-row>

    <v-divider class="my-8" />
  </div>
</template>

<script>
import { catalogDate } from '@/util/catalog'

export default {
  name: 'AppointmentDivergenceInfo',

  props: {
    appointment: {
      type: Object,
    },
  },

  computed: {
    contest() {
      return this.appointment?.divergence_contest || {}
    },

    hasDivergence() {
      return Boolean(this.appointment?.divergence_contest)
    },

    types() {
      const types = this.contest.types || []
      if (!types.length) return '---'
      return types.map((type) => this.$t(`appointment.divergenceType.${type}`)).join(', ')
    },

    /** Sem data quando a imobiliária não usa prazo: nesse caso pode reclamar a qualquer momento. */
    deadlineLabel() {
      if (!this.contest.contest_deadline) {
        return this.$t('appointment.label.divergenceContestNoDeadline')
      }
      return catalogDate(this.contest.contest_deadline)
    },
  },
}
</script>
